Property_booking =
{
	init : function()
	{
		Property_booking.init_ui();
	}
	,
	init_ui : function()
	{
		// Handles the show booking link from a mobile page. 
		jQuery('.oc-show-booking-link').click(function(event){
			// Emit show booking modal event on the document.
			var config = {};
			//config.zoo = 'poo';
			jQuery(document).trigger('oc_booking_modal_show',config);
			
			event.preventDefault();
		});
		
		// Handles the close booking link from a mobile page. 
		jQuery('.oc-close-booking-link').click(function(event){
			// Emit show booking modal event on the document.
			var config = {};
			//config.zoo = 'poo';
			jQuery(document).trigger('oc_booking_modal_close',config);
			
			event.preventDefault();
		});
		
		// Respond to Search Form Submission.
		jQuery(document).on('oc_property_detail_search_submit',function(event,pm_options){
			//jQuery('body').removeClass('oc-show-booking');
			console.log('PROPERTY DETAIL SEARCH SUBMIT');
			Property_booking.close();
		});
		
		// Listen and respond to show booking modal event.
		jQuery(document).on('oc_booking_modal_show',function(event,pm_config){
			// Add body class
			//jQuery('body').addClass('oc-show-booking');
			Property_booking.open();
		});
		
		// Listen and respond to close booking modal event.
		jQuery(document).on('oc_booking_modal_close',function(event,pm_config){
			// Remove body class
			//jQuery('body').removeClass('oc-show-booking');
			Property_booking.close();
		});
	}
	,
	open : function()
	{
		jQuery('body').addClass('oc-show-booking');
	}
	,
	close : function()
	{
		jQuery('body').removeClass('oc-show-booking');
	}
}

jQuery(document).ready(function(jQuery){
	Property_booking.init();
});
